import {
  AttachedByTypeApi,
  AttachmentAttachedToTypeApi,
  AttachmentTypeApi,
} from 'api-typings/common/common';
import type { Attachment } from './feed-posts.model';

/**
 * Checks if a value is a valid Attachment object.
 * Returns true if the object has all required properties with correct types.
 */
export function isAttachment(value: unknown): value is Attachment {
  // Quick null/undefined check
  if (!value || typeof value !== 'object') {
    return false;
  }

  const obj = value as any;

  if (
    // Check required properties
    typeof obj.id !== 'number' ||
    typeof obj.created !== 'number' ||
    typeof obj.position !== 'number' ||
    // First, make sure the properties exist
    obj.attachedToType === undefined ||
    obj.attachedObjectType === undefined ||
    obj.attachedByType === undefined
  ) {
    return false;
  }

  // Then check they have valid values
  const validAttachedToTypes = Object.values(AttachmentAttachedToTypeApi);
  const validObjectTypes = Object.values(AttachmentTypeApi);
  const validByTypes = Object.values(AttachedByTypeApi);

  if (
    !validAttachedToTypes.includes(obj.attachedToType) ||
    !validObjectTypes.includes(obj.attachedObjectType) ||
    !validByTypes.includes(obj.attachedByType)
  ) {
    return false;
  }

  // Check optional properties if they exist
  if (obj.attachedToId !== undefined && typeof obj.attachedToId !== 'number') {
    return false;
  }

  if (
    obj.attachedObjectId !== undefined &&
    typeof obj.attachedObjectId !== 'string'
  ) {
    return false;
  }

  if (obj.attachedById !== undefined && typeof obj.attachedById !== 'number') {
    return false;
  }

  if (
    obj.attachmentUuid !== undefined &&
    typeof obj.attachmentUuid !== 'string'
  ) {
    return false;
  }

  // All checks passed
  return true;
}
